import styled from '@emotion/styled';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { GetExploreCharacterData } from '~/types';
import CharacterCard, {
  CharacterCardClickEvent,
} from '../CharacterCard/CharacterCard';

export interface HorizontalCardSlideProps {
  imageWidth?: number;
  images: GetExploreCharacterData[];
  handleCardClick: ({ id, name, desc, type }: CharacterCardClickEvent) => void;
  handleLikeClick: (id: string, isLiked: boolean) => void;
}

export default function HorizontalCardSlide({
  imageWidth = 147,
  images,
  handleCardClick,
  handleLikeClick,
}: HorizontalCardSlideProps) {
  return (
    <>
      {images?.length > 0 && (
        <SwiperContainer
          spaceBetween={8}
          slidesPerView={'auto'}
          freeMode={true}
          modules={[FreeMode]}
        >
          {images.map(
            ({
              character_id,
              character_image,
              character_name,
              character_desc,
              is_liked,
              create_username,
              liked_count,
              type,
            }) => (
              <SwiperSlide
                key={character_id}
                style={{ width: `${imageWidth}px`, cursor: 'pointer' }}
              >
                <CharacterCard
                  id={character_id}
                  image={character_image}
                  name={character_name}
                  desc={character_desc}
                  create_username={create_username}
                  is_liked={is_liked}
                  liked_count={liked_count}
                  handleLikeClick={handleLikeClick}
                  handleCardClick={handleCardClick}
                  type={type}
                />
              </SwiperSlide>
            ),
          )}
        </SwiperContainer>
      )}
    </>
  );
}

export const SwiperContainer = styled(Swiper)`
  &.swiper {
    padding-right: ${({ theme }) => theme.layout.section_side};
  }
`;
